import { render } from "./UtopiaUpdate.vue?vue&type=template&id=ade516fe&scoped=true"
import script from "./UtopiaUpdate.vue?vue&type=script&lang=js"
export * from "./UtopiaUpdate.vue?vue&type=script&lang=js"

import "./UtopiaUpdate.vue?vue&type=style&index=0&id=ade516fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ade516fe"]])

export default __exports__